/** Keep only currently accessible team IDs, preserving the user's selection order. */
export function accessibleTeamSelection(selected: string[], accessible: string[]): string[] {
  const allowed = new Set(accessible);
  return [...new Set(selected)].filter((teamId) => allowed.has(teamId));
}

/** Keep a valid intentional selection; if every stored ID disappeared, return to captain defaults. */
export function restoreAccessibleTeamSelection(selected: string[], captainDefaults: string[], accessible: string[]): string[] {
  const valid = accessibleTeamSelection(selected, accessible);
  return selected.length > 0 && valid.length === 0
    ? accessibleTeamSelection(captainDefaults, accessible)
    : valid;
}

export function sameTeamSelection(left: string[], right: string[]): boolean {
  return left.length === right.length && left.every((id, index) => id === right[index]);
}

/** A stored empty selection is intentional (All Teams); a fresh empty default is not. */
export function shouldShowCaptainScopeEmpty(
  selected: string[],
  captainDefaults: string[],
  scopeMode: 'default' | 'explicit',
): boolean {
  return scopeMode === 'default' && selected.length === 0 && captainDefaults.length === 0;
}
